/**
 * Replace the password in a database URL with bullets.
 *
 * Mongo and SQL URLs share the scheme://user:password@host shape. Only the
 * password segment is hidden: the host, port and database name stay readable so
 * the string is still recognisable as the right one.
 */
export const maskConnectionString = (connectionString?: string | null): string => {
  if (!connectionString) return "";
  return connectionString.replace(
    /^([a-zA-Z][\w+.-]*:\/\/[^:@/]+):[^@]+@/,
    (_, prefix) => `${prefix}:••••••••@`
  );
};

/** Whether the string carries a password worth hiding. */
export const hasPassword = (connectionString?: string | null): boolean =>
  !!connectionString &&
  maskConnectionString(connectionString) !== connectionString;
